import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import PageBuilder from './PageBuilder';
import NavManager from './NavManager';
import VideoManager from './VideoManager';
import UserManager from './UserManager';
import '../../pages.css';

const TABS = [
  { id: 'page', label: '页面构建', Component: PageBuilder },
  { id: 'nav', label: '导航管理', Component: NavManager },
  { id: 'videos', label: '视频管理', Component: VideoManager },
  { id: 'users', label: '用户管理', Component: UserManager },
];

export default function Admin() {
  const { isAdmin, loading } = useAuth();
  const [tab, setTab] = useState('page');

  if (loading) return <div className="admin-shell">加载中…</div>;
  if (!isAdmin) return <div className="admin-shell"><p>无权限访问管理后台。</p></div>;

  const Active = TABS.find((t) => t.id === tab).Component;

  return (
    <div className="admin-shell">
      <h1>管理后台</h1>
      <div className="admin-nav">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={t.id === tab ? 'active' : ''}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
